let fadeOptions = {
"duration": 500,
"delay": 0
};

export function anchorheader_viewportLeave() {
    $w("#stripshow").show('fade', 'fadeOptions');
}

export function anchorheader_viewportEnter() {
    $w("#stripshow").hide('fade', 'fadeOptions');
}